import Ellipse from "../../../shapes/shapes/Ellipse";
import Rectangle from "../../../shapes/shapes/Rectangle";
import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class MoveLabelsAction extends AbstractProvidedClass {
    movedX = 0;
    movedY = 0;
    initialX;
    initialY;

    constructor(provider, labelCollection) {
        super(provider);

        this.labelCollection = labelCollection;

        this.initialX = this.labelCollection.absX;
        this.initialY = this.labelCollection.absY;

        this.lastMouseAbsX = (this.p.mouseX - this.view.posX) / this.view.scale;
        this.lastMouseAbsY = (this.p.mouseY - this.view.posY) / this.view.scale;
    }

    update() {
        let mouseAbsX = (this.p.mouseX - this.view.posX) / this.view.scale;
        let mouseAbsY = (this.p.mouseY - this.view.posY) / this.view.scale;
        let moveX = mouseAbsX - this.lastMouseAbsX;
        let moveY = mouseAbsY - this.lastMouseAbsY;
        this.lastMouseAbsX = mouseAbsX;
        this.lastMouseAbsY = mouseAbsY;

        if (moveX != 0 || moveY != 0) {
            this.movedX += moveX;
            this.movedY += moveY;
            this.labelCollection.drag(moveX, moveY);
        }
    }

    finish() {
        this.actions.finish();
    }

    undo() {
        this.labelCollection.drag(-this.movedX, -this.movedY);
    }

    redo() {
        this.labelCollection.drag(this.movedX, this.movedY);
    }
}
